import { render, staticRenderFns } from "./ConfSideNav.vue?vue&type=template&id=311cc440&scoped=true&"
import script from "./ConfSideNav.vue?vue&type=script&lang=js&"
export * from "./ConfSideNav.vue?vue&type=script&lang=js&"
import style0 from "./ConfSideNav.vue?vue&type=style&index=0&id=311cc440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311cc440",
  null
  
)

export default component.exports